import React from 'react';
import { HMobiledataOutlined } from '@mui/icons-material';
import { Heading, HeadingPropsSchema } from './Heading';
import HeadingSidebarPanel from './HeadingSidebarPanel';
export default {
    label: 'Heading',
    icon: React.createElement(HMobiledataOutlined, null),
    type: 'Heading',
    defaultData: {
        props: {
            text: 'Email Heading',
            level: 'h1',
        },
        style: {
            fontWeight: 'bold',
            padding: { top: 16, bottom: 16, left: 24, right: 24 },
        },
    },
    SidebarPanel: HeadingSidebarPanel,
    Component: Heading,
    schema: HeadingPropsSchema,
};
//# sourceMappingURL=index.js.map